import type { TranslationMap } from '../i18n';

export const it: TranslationMap = {
  // Auth - Common
  'auth.email': 'E-mail',
  'auth.password': 'Password',
  'auth.firstName': 'Nome',
  'auth.lastName': 'Cognome',
  'auth.back': '← Indietro',
  'auth.acceptTerms': 'Accetto i',
  'auth.termsAndConditions': 'Termini e condizioni',
  'auth.verificationRequired': 'Verifica richiesta',
  'auth.verificationLinkSent': 'Clicca sul link di verifica nella tua casella di posta.',
  'auth.sending': 'Invio in corso...',
  'auth.resendLink': 'Invia di nuovo il link',
  'auth.phonePlaceholder': 'xxx xxx xxxx',

  // Auth - Login
  'auth.signIn': 'Accedi',
  'auth.signingIn': 'Accesso in corso...',
  'auth.resetPassword': 'Reimposta password',
  'auth.createAccount': 'Crea un account',
  'auth.logIn': 'Accedi',
  'auth.logInToPurchase': 'Accedi per acquistare',

  // Auth - Account Create
  'auth.zipcodeOptional': 'CAP (facoltativo)',
  'auth.zipcodePlaceholder': 'CAP',
  'auth.phoneNumberOptional': 'Numero di telefono (facoltativo)',
  'auth.phoneNumber': 'Numero di telefono',
  'auth.birthdayOptional': 'Data di nascita (facoltativo)',
  'auth.birthday': 'Data di nascita',
  'auth.subscribeToMarketing': 'Iscriviti alle e-mail di marketing',
  'auth.create': 'Crea',
  'auth.creating': 'Creazione in corso...',
  'auth.alreadyHaveAccount': 'Hai già un account?',

  // Auth - Reset Password
  'auth.submit': 'Invia',

  // Auth - Errors
  'auth.errorUnableToSignIn': 'Impossibile accedere. Riprova.',
  'auth.errorLoginGeneric': "Si è verificato un errore durante l'accesso. Riprova.",
  'auth.errorRequiredFields': 'Campi obbligatori mancanti. Compila il modulo.',
  'auth.errorCreateGeneric': 'Si è verificato un errore. Riprova.',
  'auth.errorCreateAccount':
    "Si è verificato un errore durante la creazione dell'account. Riprova.",
  'auth.errorEmailNotFound': 'Campo e-mail non trovato. Riprova.',
  'auth.errorEnterEmail': 'Inserisci il tuo indirizzo e-mail.',
  'auth.errorResetPassword': 'Impossibile reimpostare la password. Riprova.',
  'auth.errorResetGeneric':
    'Si è verificato un errore durante il ripristino della password. Riprova.',
  'auth.error.login_required': 'Accesso richiesto. Inserisci la tua e-mail e la password.',
  'auth.error.invalid_credentials': 'E-mail o password non validi. Riprova.',
  'auth.error.account_already_exists':
    "Esiste già un account con questa e-mail. Effettua l'accesso.",
  'auth.error.invalid_email': "L'indirizzo e-mail inserito non è valido. Riprova.",
  'auth.error.weak_password': 'La tua password è troppo debole. Scegli una password più sicura.',
  'auth.error.missing_fields': 'Tutti i campi sono obbligatori. Completa il modulo.',
  'auth.error.invalid_name': 'Il nome inserito non è valido. Usa solo lettere.',
  'auth.error.password_mismatch': 'Le password non corrispondono. Riprova.',
  'auth.error.missing_email': 'Inserisci il tuo indirizzo e-mail.',
  'auth.error.email_not_found':
    'Non abbiamo trovato alcun account con questo indirizzo e-mail. Controlla e riprova.',
  'auth.error.email_verify': 'Verifica il tuo indirizzo e-mail e riprova.',
  'auth.error.captcha_challenge':
    'È richiesta una verifica aggiuntiva. Completa il controllo di sicurezza.',
  'auth.error.unknown_error': 'Si è verificato un errore sconosciuto. Riprova più tardi.',

  // Product
  'product.buyNow': 'Acquista ora',
  'product.soldOut': 'Esaurito',
  'product.processing': 'Elaborazione in corso...',
  'product.errorAddToCart': 'Impossibile aggiungere al carrello.',

  // Need Access
  'access.logInToWatch': 'Accedi per guardare',
  'access.purchaseAccess': "Acquista l'accesso",
  'access.joinOrPurchase': "Unisciti alla comunità o acquista l'accesso",
  'access.noAccess': 'Non hai accesso a questo contenuto',
  'access.joinToUnlock': 'Unisciti per sbloccare',
  'access.joinForAccess': 'Unisciti per accedere',
  'access.locked': 'Bloccato',
  'access.joinToWatch': 'Unisciti per guardare',
  'access.joinOrPurchaseAccess': "Unisciti o acquista l'accesso",
  'access.alreadyPurchased': 'Già acquistato?',
  'access.logInWithEmail': "Accedi con l'email usata per l'acquisto",
  'access.or': '- o -',
  'access.noProductsAvailable': "Al momento non sono disponibili prodotti che concedono l'accesso",
  'access.upgradeToAccess': "Esegui l'upgrade per accedere",

  // Perks
  'perks.posts': 'Post',
  'perks.videos': 'Video',
  'perks.merch': 'Merch',
  'perks.codes': 'Codici',
  'perks.music': 'Musica',
  'perks.recentPosts': 'Post recenti',
  'perks.myAccount': 'Il mio account',
  'perks.logout': 'Esci',
  'perks.noActiveMemberships': 'Nessun abbonamento attivo.',
  'perks.generating': 'Generazione in corso...',
  'perks.noCodesFound': 'Nessun codice trovato',
  'perks.noProducts': 'Nessun prodotto',
  'perks.foundFor': 'trovato per "{query}"',
  'perks.more': 'Altro',
  'perks.join': 'Unisciti',
  'perks.collectibles': 'Oggetti da collezione',
  'perks.popularPosts': 'Post popolari',
  'perks.noPosts': 'Nessun post',
  'perks.adjustFilters': 'Prova a modificare i filtri o torna presto!',
  'perks.loadMorePosts': 'Carica altri post',
  'perks.loadMore': 'Carica altro',
  'perks.memberSince': 'Membro dal',
  'perks.continueReading': 'Continua a leggere',
  'perks.joinToContinueReading': 'Unisciti per continuare a leggere',
  'perks.beFirstToComment': 'Sii il primo a lasciare un commento!',
  'perks.addComment': 'Aggiungi un commento...',
  'perks.addCommentButton': 'Aggiungi un commento',
  'perks.joinToComment': 'Unisciti per commentare',
  'perks.commentRemoved': '[ rimosso ]',
  'perks.commentHasBeenRemoved': 'Il commento è stato rimosso.',
  'perks.reply': 'Rispondi',
  'perks.replyToComment': 'Rispondi al commento...',
  'perks.viewReplies': 'Visualizza le risposte',
  'perks.loadMoreReplies': 'Carica altre risposte',
  'perks.replyCount.one': '1 risposta',
  'perks.replyCount.other': '{count} risposte',
  'perks.filterPosts': 'Filtra post',
  'perks.postType': 'Tipo di post',
  'perks.postTypeText': 'Testo',
  'perks.postTypeImages': 'Immagini',
  'perks.postTypeVideos': 'Video',
  'perks.postTypeProducts': 'Prodotti',
  'perks.postTypeAudio': 'Audio',
  'a11y.play': 'Riproduci',
  'a11y.pause': 'Pausa',
  'a11y.seek': 'Avanzamento',
  'a11y.audioArtwork': 'Copertina audio',
  'a11y.trackArtwork': 'Copertina di {title}',
  'a11y.viewArtwork': 'Vedi copertina',
  'perks.tags': 'Tag',
  'perks.authors': 'Autori',
  'perks.submission.submitPost': 'Invia un post',
  'perks.submission.createPost': 'Crea un post',
  'perks.submission.postingAs': 'Pubblichi come',
  'perks.submission.loginRequired': 'Accedi al tuo account per condividere un post.',
  'perks.submission.titleLabel': 'Titolo',
  'perks.submission.titlePlaceholder': 'Dai un titolo al tuo post',
  'perks.submission.captionLabel': 'Didascalia',
  'perks.submission.captionPlaceholder': 'Aggiungi una didascalia',
  'perks.submission.addImage': 'Aggiungi una foto',
  'perks.submission.changeImage': 'Cambia foto',
  'perks.submission.uploading': 'Caricamento in corso...',
  'perks.submission.submit': 'Invia per la revisione',
  'perks.submission.submitting': 'Invio in corso...',
  'perks.submission.post': 'Pubblica',
  'perks.submission.posting': 'Pubblicazione in corso...',
  'perks.submission.postAnother': 'Pubblica un altro',
  'perks.submission.success': 'Inviato! Il tuo post è in attesa di revisione.',
  'perks.submission.successPublished': 'Il tuo post è online.',
  'perks.submission.submitAnother': 'Invia un altro',
  'perks.submission.invalidImageType': "Scegli un'immagine JPG, PNG o GIF.",
  'perks.submission.invalidImageSize': 'Le immagini devono essere inferiori a 25 MB.',
  'perks.submission.errorUploadImage':
    "Si è verificato un problema durante il caricamento dell'immagine. Riprova.",
  'perks.submission.errorSubmit': "Si è verificato un problema durante l'invio del post. Riprova.",
  'perks.submission.errorLimit': 'Limite di invii raggiunto. Riprova domani.',
  'perks.submission.errorUsername': 'Il nome utente non è disponibile per gli invii',
  'perks.submission.removeImage': 'Rimuovi foto',
  'perks.badge.artist': 'Verificato',
  'perks.badge.team': 'Team',
  'perks.shadowBanned': 'Shadow ban: solo questo fan e i moderatori possono vederlo. Revocalo nella dashboard di Single, in Post > Impostazioni.',
  'perks.artistProfileManaged': 'Il tuo profilo artista è gestito nella dashboard di Single',
  'perks.clearAll': 'Cancella tutto',
  'perks.applyFilters': 'Applica filtri',
  'perks.backToFeed': '← Torna al feed',
  'perks.backToLibrary': '← Torna alla libreria',
  'music.album': 'Album',
  'music.download': 'Scarica',
  'music.loginToDownload': 'Accedi per scaricare',
  'music.linkExpired': 'Questo link è scaduto.',
  'music.loginToAccess':
    "Accedi utilizzando l'e-mail fornita durante l'acquisto per ascoltare o scaricare.",
  'perks.noVideos': 'Nessun video',
  'perks.noMusic': 'Nessuna musica',
  'perks.gridView': 'Vista a griglia',
  'perks.listView': 'Vista elenco',
  'perks.oops': 'Oops!',
  'perks.notFound': '404: Not Found',
  'perks.goBack': 'Torna indietro',
  'perks.account': 'Account',
  'perks.displayName': 'Nome visualizzato',
  'perks.emailPreferences': 'Preferenze e-mail',
  'perks.emailPreference.POST_NOTIFICATIONS': 'Nuovi post',
  'perks.emailPreference.POST_NOTIFICATIONS.description':
    "Ricevi un'e-mail quando viene pubblicato un nuovo post.",
  'perks.emailPreference.COMMENT_NOTIFICATIONS': 'Commenti e risposte',
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description':
    "Ricevi un'e-mail quando qualcuno risponde al tuo commento.",
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.submissions':
    "Ricevi un'e-mail quando qualcuno risponde al tuo commento o commenta un post che hai inviato.",
  'perks.emailPreference.COMMENT_NOTIFICATIONS.description.author':
    "Ricevi un'e-mail quando qualcuno risponde al tuo commento o commenta un post che hai pubblicato.",
  'perks.comments': 'Commenti',
  'perks.view': 'Visualizza',
  'perks.transfer': 'Trasferisci',
  'perks.logInToViewCollectibles': 'Accedi per visualizzare i collezionabili',
  'perks.viewAll': 'Visualizza tutto',
  'perks.errorUploadAvatar': "Impossibile caricare l'avatar. Riprova.",
  'perks.profileCardTitle': 'Benvenuto! Completiamo il tuo profilo da membro.',
  'perks.walletCardTitle': 'Scarica la tua tessera di iscrizione',
  'perks.walletPassDescription':
    'Il tuo pass membro è una tessera del club digitale per il tuo dispositivo Apple o Android. Sarà utilizzato per concederti vantaggi speciali agli spettacoli e di persona.',
  'perks.walletScanDescription':
    'Scansiona il codice QR con il tuo telefono per scaricare il tuo pass.',
  'perks.updatingProfile': 'Aggiornamento...',
  'perks.updateProfile': 'Aggiorna profilo',
  'perks.displayNamePlaceholder': 'Scrivi qui il tuo nome...',
  'perks.usernamePlaceholder': 'Nome utente',
  'perks.profileVisibilityNote':
    'Solo il tuo avatar e il tuo nome visualizzato saranno visibili agli altri membri.',
  'perks.trackCount': '{count} brani',
  'perks.trackCountOne': '{count} brano',
  'perks.commentCount': '{count} commenti',
  'perks.commentCountOne': '{count} commento',
  'perks.replyingTo': 'In risposta a @{name}',
  'perks.postCommentButton': 'Pubblica',
  'perks.avatarAlt': 'Avatar di {name}',
  'perks.hiddenPostImageAlt': 'Immagine del post nascosto',
  'perks.postImageAlt': 'Immagine del post',
  'perks.imageSlideAlt': 'Immagine della sequenza',
  'perks.videoThumbnailAlt': 'Anteprima del video',
  'perks.productImageAlt': 'Prodotto',
  'perks.membershipImageAlt': "immagine dell'abbonamento",
  'perks.tierImageAlt': 'immagine del livello',
  'perks.authorImageAlt': "immagine dell'autore",
  'perks.submission.previewAlt': "anteprima dell'invio",
  'a11y.countryCode': 'Prefisso internazionale',
  'a11y.dismiss': 'Chiudi',

  // Address Modal
  'address.updateAddress': "Aggiorna l'indirizzo",
  'address.firstName': 'Nome',
  'address.lastName': 'Cognome',
  'address.street': 'Via',
  'address.streetLine2': 'Via (riga 2)',
  'address.city': 'Città',
  'address.country': 'Paese',
  'address.province': 'Provincia',
  'address.zip': 'CAP',
  'address.phoneNumber': 'Numero di telefono',
  'address.update': 'Aggiorna',
  'address.updating': 'Aggiornamento in corso...',
  'address.errorStreetRequired': "L'indirizzo è obbligatorio",
  'address.errorCountryRequired': 'Il paese è obbligatorio',
  'address.errorZipRequired': 'Il CAP è obbligatorio',
  'address.errorPhoneRequired': 'Il numero di telefono è obbligatorio',

  // Common
  'common.cancel': 'Annulla',
  'common.ok': 'Ok',
  'common.close': 'Chiudi',
  'common.dialog': 'Finestra di dialogo',
  'a11y.communityNav': 'Pagine della community',
  'a11y.likePost': 'Metti mi piace al post',
  'a11y.unlikePost': 'Rimuovi mi piace dal post',
  'a11y.viewComments': 'Visualizza i commenti',
  'a11y.previousSlide': 'Immagine precedente',
  'a11y.nextSlide': 'Immagine successiva',
  'a11y.goToSlide': "Vai all'immagine {number}",
  'a11y.collapseComment': 'Comprimi commento',
  'a11y.expandComment': 'Espandi commento',
  'a11y.commentMenu': 'Opzioni del commento',
  'a11y.deleteComment': 'Elimina commento',
  'a11y.likeComment': 'Metti mi piace al commento',
  'a11y.unlikeComment': 'Rimuovi mi piace dal commento',
  'a11y.reply': 'Rispondi',
  'a11y.closeReplies': 'Chiudi le risposte',
  'a11y.backToFeed': 'Torna al feed',
  'a11y.uploadAvatar': 'Carica avatar',
  'common.searchByTitle': 'Cerca per titolo',
  'common.search': 'Cerca',
  'common.clear': 'Cancella',
  'common.error': 'Errore',
  'common.save': 'Salva',
  'common.saving': 'Salvataggio...',
  'common.edit': 'Modifica',
  'common.delete': 'Elimina',
  'common.loading': 'Caricamento...',
  'common.uploading': 'Caricamento in corso...',
  'common.readMore': 'leggi di più',
  'common.readLess': 'leggi meno',
  'common.share': 'Condividi',
  'common.copied': 'Copiato!',
  'common.browserShareError':
    'Il tuo browser non supporta le funzionalità di condivisione o appunti.',
  'common.alreadyMember': 'Sei già un membro?',

  // Membership
  'membership.confirm': 'Conferma',
  'membership.nevermind': 'Non importa',
  'membership.noGoBack': 'No, Torna indietro',
  'membership.yesCancel': 'Sì, Annulla',
  'membership.goBack': 'Torna indietro',
  'membership.continue': 'Continua',
  'membership.confirmChange': 'Conferma modifica',
  'membership.termsAndConditions': 'Termini e condizioni',
  'membership.updateBillingTerms': 'Aggiorna i tuoi termini di fatturazione',
  'membership.confirmYourChanges': 'Conferma le tue modifiche',
  'membership.confirmUpgrade': 'Conferma aggiornamento',
  'membership.confirmDowngrade': 'Conferma downgrade',
  'membership.termChange': 'Cambio di termine',
  'membership.labelCancellation': 'Cancellazione {label}',
  'membership.cancelPendingTitle': 'Annulla {change}',
  'membership.yesCancelPending': 'Sì, annulla {change}',
  'membership.revertSettings': 'Il tuo {label} tornerà alle impostazioni precedenti.',
  'membership.cancelTitle': 'Annulla {label}',
  'membership.areYouSureCancel': 'Sei sicuro di voler annullare?',
  'membership.cancellationEndOfTerm':
    'La tua cancellazione entrerà in vigore alla fine del tuo periodo.',
  'membership.stillHaveAccess':
    'Tuttavia, avrai ancora accesso al tuo {label} a pagamento per il resto del tuo periodo.',
  'membership.expirationDate': 'Data di scadenza {label}:',
  'membership.notice': 'Avviso:',
  'membership.cancellationNotice':
    'Le cancellazioni {label} non avranno effetto fino alla fine del tuo periodo.',
  'membership.contactForQuestions': 'Per domande sulla cancellazione del tuo {label}, contatta',
  'membership.contactIfUnsure':
    'Se non sei sicuro che questo si applichi al tuo ordine specifico, contatta il servizio clienti.',
  'membership.cancelMembershipButton': 'Annulla abbonamento',
  'membership.currentPlan': 'Piano attuale',
  'membership.newPlan': 'Nuovo piano',
  'membership.newPlanStarts': 'Il tuo nuovo piano inizia il',
  'membership.newTierTerm': 'Nuovo termine di livello:',
  'membership.nextBillingDateLabel': 'Prossima data di fatturazione:',
  'membership.perMonth': '/Mese',
  'membership.aboutToUpgrade': 'Stai per aggiornare il tuo livello di abbonamento.',
  'membership.aboutToDowngrade': 'Stai per effettuare il downgrade del tuo livello di abbonamento.',
  'membership.viewMyPerks': 'Visualizza i miei vantaggi',
  'membership.manage': 'Gestisci',
  'membership.joining': 'Iscrizione in corso...',
  'membership.join': 'Unisciti',
  'membership.addingToCart': 'Aggiunta al carrello...',
  'membership.upgrade': 'Aggiornamento',
  'membership.downgrade': 'Downgrade',
  'membership.cancelPendingChanges': 'Annulla modifiche in sospeso',
  'membership.active': 'Attivo',
  'membership.nextBillingDate': 'Prossima fatturazione',
  'membership.term': 'Periodo',
  'membership.changeTerm': '(modifica)',
  'membership.price': 'Prezzo',
  'membership.free': 'GRATUITO',
  'membership.per': 'per',
  'membership.oneTimePurchase': 'Acquisto singolo',
  'membership.noMembershipsAvailable': 'Nessun abbonamento disponibile',
  'membership.transactionFailed': 'Transazione {label} fallita - Clicca per aggiornare',
  'membership.noActiveMemberships': 'Nessun abbonamento attivo',
  'membership.pending': 'In sospeso',
  'membership.cancellation': 'Cancellazione',
  'membership.upgradeDowngrade': 'Aggiornamento / Downgrade',
  'membership.cancelLink': 'Annulla',
  'membership.nextShipment': 'Prossima spedizione •',
  'membership.viewProduct': 'Visualizza prodotto',
  'membership.hasBeenScheduled': 'è stato pianificato.',
  'membership.changingTo': 'Cambio in:',
  'membership.willBeDowngradedTo': 'Il tuo {label} verrà declassato a',
  'membership.on': 'il',
  'membership.stillHaveAccessUntil': 'Avrai ancora accesso fino al',
  'membership.cancelChange': 'Annulla modifica',
  'membership.nextBilling': 'Prossima fatturazione',
  'membership.subscriptionShipMonthly': 'Gli ordini di abbonamento vengono spediti mensilmente.',
  'membership.noUpcomingBillDates': 'Nessuna data di fatturazione imminente.',
  'membership.orderHistory': 'Storico ordini',
  'membership.emailWithTracking':
    "Riceverai un'email con il tracking una volta spedito il tuo ordine.",
  'membership.back': '← Indietro',
  'membership.shippingAddress': 'Indirizzo di spedizione',
  'membership.missingAddress': "Informazioni sull'indirizzo mancanti. Clicca per aggiornare.",
  'membership.editShippingAddress': 'Modifica indirizzo di spedizione',
  'membership.paymentMethod': 'Metodo di pagamento',
  'membership.updatePaymentInstructions':
    "Per aggiornare il tuo metodo di pagamento, usa il link qui sotto. Ti verrà inviata un'email con le istruzioni.",
  'membership.updatePaymentMethod': 'Aggiorna metodo di pagamento',
  'membership.paymentFailed': 'Pagamento fallito',
  'membership.productImageAlt': 'immagine del prodotto',
  'membership.detailMembership': 'Abbonamento',
  'membership.detailBilling': 'Fatturazione',
  'membership.detailPlan': 'Piano',
  'membership.detailMemberId': 'ID membro',
  'membership.detailSubscriptionNumber': 'N. abbonamento',
  'membership.detailStatus': 'Stato',
  'membership.detailTerms': 'Condizioni',
  'membership.detailLastPayment': 'Ultimo pagamento',
  'membership.receivedOn': 'Ricevuto il {date}',
  'membership.receivedAmountOn': '{amount} ricevuto il {date}',
  'membership.detailName': 'Nome',
  'membership.detailStreet': 'Via',
  'membership.detailCity': 'Città',
  'membership.detailState': 'Provincia',
  'membership.detailZip': 'CAP',
  'membership.detailCountry': 'Paese',
  'membership.detailPhone': 'Telefono',
  'membership.detailCard': 'Carta',
  'membership.detailNumber': 'Numero',
  'membership.detailExpires': 'Scadenza',
  'membership.detailMethod': 'Metodo',
  'membership.manageLabel': 'Gestisci {label}',

  // Music
  'music.exclusive': 'Esclusivo',
  'music.trackTitle': 'Titolo',
  'music.songCount': '{count} brani',
  'music.songCountOne': '{count} brano',
  'music.allTracksAvailableIn': 'TUTTI I BRANI DISPONIBILI TRA:',
  'music.preorderUnlock':
    "Preordina ora e sblocca l'accesso allo streaming o al download il {date}.",
  'music.downloadUnavailable': 'Download non disponibile',
  'music.downloadLimitReached': 'Hai raggiunto il limite di download. Contatta il negozio.',
  'music.downloadFailed': 'Download non riuscito. Riprova.',
  'music.downloadNotAllowed': "Accedi con l'email usata per l'acquisto.",
  'music.downloadCodeUnavailable': 'Questo download non è disponibile. Contatta il negozio.',
  'music.downloadStarted': 'Download avviato',
  'music.downloadStartedHint': "Controlla i tuoi download o l'app File.",
  'music.openInBrowserTitle': 'Download bloccato',
  'music.openInBrowserBody':
    'Il browser in-app che stai usando blocca i download. Devi aprire questa pagina in un browser esterno.',
  'music.openInBrowserHint':
    "Tocca l'icona ••• e seleziona «Apri nel browser esterno» per continuare.",
  'music.demoArtist': 'Artista di prova',
  'music.demoAlbum': 'Album demo',
  'music.demoTrack': 'Brano {n}',
  'a11y.previousTrack': 'Brano precedente',
  'a11y.nextTrack': 'Brano successivo',
  'a11y.playAll': 'Riproduci tutto',

  // Video
  'video.startsIn': 'Inizia tra:',
  'video.previewTitle': 'Titolo del video',
  'video.previewArtist': "Nome dell'artista",
  'video.previewDescription': 'Descrizione del video',
};
